export enum Status {
  SUSPICIOUS = 'suspicious',
  SAFE = 'safe'
}

export enum IntroType {
  order = 'order',
  cutoff = 'cutoff'
}

export type SuspiciousAbuseStatusResponse = {
  status: Status.SUSPICIOUS
  abuseCaseId: number
  reason: string
  payload: {
    orderCreationId: number
    shippingDate: string
    cutOffDate: string
  }
}

export type AbuseStatusResponse =
  | {
      status: Status.SAFE
    }
  | SuspiciousAbuseStatusResponse
